import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {tap} from 'rxjs/operators';
import {LocalStorageService} from '../_services/local-storage.service';
import {HttpStatusCode} from '../_enums/http-status-codes.enum';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
	constructor(private router: Router, private localStorageService: LocalStorageService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Skip auth header for public onboarding routes (unauthenticated clients)
		// But NOT for generate-link which is authenticated (for salespersons)
		if (request.url.includes('/web-onboarding/') && !request.url.includes('/generate-link')) {
			return next.handle(request);
		}
		// Skip auth header for merchant onboarding (OB Comercios v2) — public flow
		// with its own HttpOnly session cookie.
		if (request.url.includes('/onboarding-comercio')) {
			return next.handle(request);
		}

		const requestClone = request.clone({
			setHeaders: {
				Authorization: `Bearer ${this.localStorageService.getToken().value}`,
			},
		});
		return next.handle(requestClone).pipe(
			tap(
				(event) => {
					if (event instanceof HttpResponse) {
					}
				},
				(error) => {
					if (error instanceof HttpErrorResponse) {
						if (error.status === HttpStatusCode.Unauthorized) {
							this.router.navigate(['./login']);
						}
					}
				}
			)
		);
	}
}
